/**
 * 類似投稿検索（かんたん検索）機能の GA トラッキング
 */

export const SIMILAR_SEARCH_CUSTOM_EVENT_TYPE = 'similar_search';

export function trackSimilarSearch(action: string, label: string): void {
  window.pushCustomEvent(SIMILAR_SEARCH_CUSTOM_EVENT_TYPE, {
    action,
    label,
  });
}
